import { getTableData, changeStatus, del, find, uploadFile, saveOrUpdate, updateVideo, createVideoUrl, refreshVideoUrl } from '@/axios/api/newVideoManagement'
import { Message } from 'element-ui'

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'

const state = {
  tableData: [],
  tblLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    id: undefined,
    keyword: undefined,
    categoryId: undefined,
    languageId: undefined,
    segmentId: undefined,
    videoYear: undefined,
    formId: undefined,
    lifestyleId: undefined,
    tagId: undefined,
    startTime: undefined,
    endTime: undefined,
    date: [],
    enable: undefined
  },
  detail: {},
  detailLoading: false
}
const getters = {
  tableData: state => state.tableData,
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params,
  detail: state => state.detail,
  detailLoading: state => state.detailLoading
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData({
        ...params
      })
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 删除
  async delApi ({ commit }, params) {
    try {
      const res = await del(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  // 切换状态
  async changeStatusApi ({ commit }, params) {
    try {
      const res = await changeStatus(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const {data: res} = await find(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  async uploadFileApi ({ commit }, params) {
    try {
      return await uploadFile(params)
    } catch (e) {}
  },
  async saveOrUpdateApi ({commit}, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await saveOrUpdate(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res && res.errorCode === 200
    } catch (e) {
      commit(UPDATE_DETAIL_LOADING, false)
      return false
    }
  },
  async updateVideoApi ({ commit }, params) {
    try {
      const res = await updateVideo(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  async createVideoUrlApi ({ commit }, params) {
    try {
      const res = await createVideoUrl(params)
      return res
    } catch (e) {}
  },
  async refreshVideoUrlApi ({ commit }, params) {
    try {
      const res = await refreshVideoUrl(params)
      return res
    } catch (e) {}
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/newVideoManagement.js